var map = {
	"./charts/PemegangSaham-PieChart": 15,
	"./charts/PemegangSaham-PieChart.jpg": 15,
	"./charts/PemegangSaham-PieChart2": 16,
	"./charts/PemegangSaham-PieChart2.jpg": 16,
	"./charts/PemegangSaham-PieChart3": 17,
	"./charts/PemegangSaham-PieChart3.jpg": 17,
	"./charts/pemegang-saham": 18,
	"./charts/pemegang-saham.png": 18,
	"./covers/buka-deposito-sekarang": 19,
	"./covers/buka-deposito-sekarang.png": 19,
	"./home/ayo-ke-bpr": 20,
	"./home/ayo-ke-bpr.png": 20,
	"./home/image0": 21,
	"./home/image0.jpeg": 21,
	"./home/image1": 22,
	"./home/image1.jpeg": 22,
	"./logo/BPR LOGO": 23,
	"./logo/BPR LOGO.png": 23,
	"./logo/LOGO LPS": 24,
	"./logo/LOGO LPS.png": 24,
	"./logo/LOGO OJK": 25,
	"./logo/LOGO OJK.png": 25,
	"./logo/Logo Artha Budaya_Ungu": 26,
	"./logo/Logo Artha Budaya_Ungu Non Tagline": 27,
	"./logo/Logo Artha Budaya_Ungu Non Tagline.png": 27,
	"./logo/Logo Artha Budaya_Ungu.png": 26,
	"./main_slider/Deposito Berbagi": 28,
	"./main_slider/Deposito Berbagi Hari-H": 29,
	"./main_slider/Deposito Berbagi Hari-H.png": 29,
	"./main_slider/Deposito Berbagi.png": 28,
	"./main_slider/KMK": 30,
	"./main_slider/KMK.png": 30,
	"./main_slider/SI-BUIS": 31,
	"./main_slider/SI-BUIS.png": 31,
	"./main_slider/Tabungan WOW Premium": 32,
	"./main_slider/Tabungan WOW Premium.png": 32,
	"./patterns/img-placeholder": 33,
	"./patterns/img-placeholder.png": 33,
	"./pengurus/direktur-utama": 34,
	"./pengurus/direktur-utama.jpeg": 34,
	"./pengurus/komisaris": 35,
	"./pengurus/komisaris-utama": 36,
	"./pengurus/komisaris-utama.jpeg": 36,
	"./pengurus/komisaris.jpeg": 35,
	"./sosial_media/fb-full-c": 37,
	"./sosial_media/fb-full-c.png": 37,
	"./sosial_media/fb-new-full-c": 38,
	"./sosial_media/fb-new-full-c.png": 38,
	"./sosial_media/ig-full-c": 39,
	"./sosial_media/ig-full-c.png": 39,
	"./sosial_media/tw-full-c": 40,
	"./sosial_media/tw-full-c.png": 40,
	"./sosial_media/wa-full-c": 41,
	"./sosial_media/wa-full-c.png": 41,
	"./sosial_media/yt-full-c": 42,
	"./sosial_media/yt-full-c.png": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;